<template>
  <div class="file-list">
    <div class="list">
      <div v-if="fileList.length>0">
        <el-checkbox-group class="list-list" v-model="checkList" :disabled="!isAdd && !isCheck">
          <el-checkbox :label="i" v-for="(item,i) in fileList"
                       :key="'pic'+i" :value="i">{{ item.fileName }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div style="display: inline-block; float: right">
      <el-button class="el-icon-third-lajitong" @click="deleteFiles" v-if="isAdd"/>
      <el-button class="el-icon-third-xiazai" @click="downloadFiles" v-if="isCheck"/>
      <qx-upload :value.sync="fileUrl" class="qx-upload"
                v-if="isAdd"
                :show-file-list="false" :keep-file="false"
                :systemType="this.systemType"
                @uploadedFile="uploadedFile">
        <template slot="button">
          <el-button class="add-button" style="margin: 3px 4px">
            <i class="el-icon-third-jiatianjiakuangxuanduoxuan-8"/>
          </el-button>
        </template>
      </qx-upload>
    </div>
  </div>
</template>

<script>
/**
 * @description 文件上传组件
 * @author: 菩萨蛮
 * @date 2020/2/23 3:25 上午
 * @version V1.0.1
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 *
 * V1.0.1 添加文件格式
 */

import QxUpload from './QxUpload.vue'

export default {
  name: 'FileUploadList',
  props: {
    accept: { type: String, default: '.ep,.cmd,.wac,.xml' },
    fileList: { type: Array, default: () => [] },
    isAdd: { type: Boolean, default: () => true },
    isCheck: { type: Boolean, default: () => true },
    systemType: { type: Number, default: 6 }
  },
  components:{ QxUpload },
  data() {
    return {
      fileUrl: '',
      checkList: []
    };
  },
  methods: {
    async downloadFiles() {
      if (!this.fileList) {
          this.$message.error('请先上传附件！');
      }
      // const uuids = this.fileList.map(f => f.uuid);
      const checkFileList = this.fileList
        .filter((e, i) => this.checkList.includes(i));
      const uuids = checkFileList.map(f => f.uuid);
      if (uuids && uuids.length) {
          const Authorization = localStorage.getItem('token');
          const res = await this.qxAxios({
              url: '/dfs/file/zip',
              method: 'post',
              responseType: 'blob',
              headers: { Authorization },
              data: {
                  uuids,
                  companyId: JSON.parse(localStorage.getItem('user')).companyId,
                  systemType: this.systemType
              }
          });
          if (res.status === 200) {
              const a = document.createElement('a');
              a.download = checkFileList.length === 1
                      ? checkFileList[0].fileName
                      : '附件.zip';
              a.href = URL.createObjectURL(res.data);
              a.click();
          }
      } else {
          this.$message.error('请选择附件！');
      }
    },
    uploadedFile(data) {
      const { url } = data;
      const urlList = url.split('/');
      this.fileList.push({
        fileName: data.file.name,
        uuid: urlList[5]
      });
    },
    deleteFiles() {
      this.$emit('update:fileList', this.fileList
        .filter((e, i) => !this.checkList.includes(i)));
    }
  }
};
</script>

<style lang="scss" scoped>

.file-list {
  width: calc(100vw - 288px);
  height: 80px;
  overflow-y: auto;

  .file-list {
    width: calc(100vw - 422px);
    overflow-x: auto;
  }

  div {
    display: inline-block;
  }
}

.list-list {
  margin: 0 12px;

  .el-image {
    width: 144px;
    height: 144px;
  }
}

.qx-upload, .el-icon-third-lajitong, .el-icon-third-xiazai {
  display: inline-block;
  float: right;
}

.el-icon-third-lajitong, .el-icon-third-xiazai {
  margin: 3px 4px !important;
}

.el-button {
  margin: 0 4px;
  width: 32px;
  height: 32px;
  background: #FFFFFF;
  box-shadow: 0 1px 3px 1px rgba(79, 118, 183, 0.25);
  border-radius: 2px;
  color: #8497B3;
}

</style>
